import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import ProjectContent from "./components/projectContent";

export default function Project() {
  return (
    <div>
      <TitleHolder>Create Project</TitleHolder>
      <StepperContentHolder>
        <ProjectContent />
      </StepperContentHolder>
    </div>
  );
}
